var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-select',{attrs:{"value":_vm.selectedCountry,"options":_vm.countries,"getOptionLabel":_vm.localizeOption},on:{"input":_vm.onCountrySelected}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aca2b472","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/presetbar/CountryFilter.vue
// module id = 684
// module chunks = 1